import { SlotsActionTypes, SlotsState, READ_SLOTS_DATA_REQUEST, READ_SLOTS_DATA_SUCCESS, READ_SLOTS_DATA_FAILURE } from "store/reducers/types/dashboard/slots";

const defaultState: SlotsState = {
  isLoading: false,
  errorMessage: ""
};

export default function slots(state = defaultState, action: SlotsActionTypes): SlotsState {
  switch (action.type) {
    case READ_SLOTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_SLOTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_SLOTS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
